import { render, staticRenderFns } from "./school_detail_info.vue?vue&type=template&id=ef41bad8&"
import script from "./school_detail_info.vue?vue&type=script&lang=js&"
export * from "./school_detail_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports